module.exports = __webpack_public_path__ + "images/back@2x.png?58c8bc1e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back@2x.png
// module id = 598
// module chunks = 7